export default "__VITE_ASSET__Cyh09hoL__"